exports = module.exports = require("../../node_modules/@vue/cli-service/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".v-layout-middle {\n  height: 100%;\n}\n.v-layout-middle__content {\n  height: 100%;\n}\n", ""]);

// exports
